export const hoverColor = 'linear-gradient(72.47deg, #005288.16%, rgba(0, 82, 136, 0.7) 76.47%)'
